import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgIcon } from '@ng-icons/core';
import { FieldArrayType, FormlyModule } from '@ngx-formly/core';
import { HlmButton } from '@spartan-ng/helm/button';
import { TranslatePipe } from '@ngx-translate/core';

/**
 * Field type do Formly para listas de objetos (fieldArray). Renderiza as linhas
 * (com os subcampos de itemFields) e o botão "Adicionar" dentro de um fieldset
 * com legenda (props.label). Usado por ex. em costs.entries (List<CostEntry>) e
 * productionOrders.productClassification.
 */
@Component({
  selector: 'evolve-repeat-section',
  imports: [ReactiveFormsModule, FormlyModule, HlmButton, NgIcon, TranslatePipe],
  template: `
    <fieldset class="mb-2 rounded-lg border border-border px-4 pb-4 pt-1">
      <legend
        class="px-2 text-sm font-semibold text-foreground"
      >
        {{ props.label ?? '' }}
      </legend>
      <div class="flex flex-col gap-2">
        @for (item of field.fieldGroup; track $index; let i = $index) {
          <div class="flex items-end gap-2">
            <formly-field class="flex-1" [field]="item" />
            <button
              hlmBtn
              variant="ghost"
              size="icon"
              class="text-destructive hover:text-destructive"
              (click)="remove(i)"
              type="button"
              [attr.aria-label]="
                'shared.forms.repeatSection.removeItem' | translate
              "
            >
              <ng-icon name="lucideTrash2" />
            </button>
          </div>
        } @empty {
          <p class="text-sm text-muted-foreground">
            {{ 'shared.forms.repeatSection.empty' | translate }}
          </p>
        }

        <div>
          <button hlmBtn variant="outline" (click)="add()" type="button">
            <ng-icon name="lucidePlus" />
            {{ 'shared.forms.repeatSection.add' | translate }}
          </button>
        </div>
      </div>
    </fieldset>
  `,
})
export class RepeatSectionFieldComponent extends FieldArrayType {}
